import { Guid } from 'guid-typescript';
import { DocumentsVm } from 'src/app/api/models/quotationSummaryResponse.model';
import { option } from 'src/app/views/devis/quote-confirmation/quote-confirmation.component';

export class ConfirmQuoteVM {
  subtitle: string;
  numberQuote: string;
  rateMonth!: string | null;
  rateYear!: string | null;
  options: option[];
  agreementId?: Guid;
  quoteDoc?: DocumentsVm[];

  constructor(
    numberQuote: string,
    subtitle: string,
    options: option[],
    agreementId?: Guid,
    quoteDoc?: DocumentsVm[]
  ) {
    this.subtitle = subtitle;
    this.numberQuote = numberQuote;
    this.options = options;
    this.quoteDoc = quoteDoc;
    this.agreementId = agreementId;
  }
}
